import React, { memo } from 'react'
import tw from 'twin.macro'
import { Typography } from '@mui/material'

interface Props {
  css?: any
  termsLinkDataTestId?: string
  policyLinkDataTestId?: string
}

const TOSComponent = ({ termsLinkDataTestId, policyLinkDataTestId, ...rest }: Props) => {
  return (
    <div {...rest}>
      <Typography css={tw`text-center text-shades-400`}>
        By continuing, you are agreeing to our &nbsp;
        <a
          css={tw`no-underline`}
          href="https://www.gigsafe.com/term"
          target="_blank"
          rel="noopener noreferrer"
          {...(termsLinkDataTestId ? { 'data-testid': termsLinkDataTestId } : {})}
        >
          <Typography
            css={tw`cursor-pointer underline inline-block text-primary-500 [font-weight: 500]`}
          >
            Terms of Service
          </Typography>
        </a>
        {' and '}
        <a
          css={tw`no-underline`}
          href="https://www.gigsafe.com/privacy-policy"
          target="_blank"
          rel="noopener noreferrer"
          {...(policyLinkDataTestId ? { 'data-testid': policyLinkDataTestId } : {})}
        >
          <Typography
            css={tw`cursor-pointer underline inline-block text-primary-500 [font-weight: 500]`}
          >
            Privacy Policy
          </Typography>
        </a>
      </Typography>
    </div>
  )
}

export const TOS = memo(TOSComponent)
